import React from 'react'
import axios from 'axios'
import { List, Box, Typography, TableContainer, Table, TableRow, TableHead, TableBody, Paper ,Button} from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { useNavigate } from 'react-router-dom'
import legolasApi from '../../api/legolas'
import { isArray } from 'lodash';
import Tooltip from '@mui/material/Tooltip';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function OrderInvoiceList(props) {
  const [columnsOpen, setColumnsOpen]= React.useState(false)
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    { id: '_id', label: 'Invoice ID' }, 
    { id: 'invoiceNumber', label: 'Invoice No.' }, 
    { id: 'orderId', label: 'Order ID'}, 
    { id: 'orderDate', label: 'Placed On'},
    { id: 'subtotal', label: 'Subtotal'}, 
    { id: 'shippingCharges', label: 'Shipping Charges' }, 
    { id: 'items', label: 'Total Items' }
  ]);  
  const [invoiceList, setInvoiceList] = React.useState([])
  const navigate = useNavigate()
  const { summary, items, shipment, transaction, customer } = props.data

  const allTableHeaders = [
 
    { id: 'incrementId', label: 'Invoice Number' }, { id: 'orderId', label: 'Order ID'}, { id: 'orderDate', label: 'Placed On'},
    { id: 'subtotal', label: 'Subtotal'}, { id: 'shippingCharges', label: 'Shipping Charges' },
    { id: 'items', label: 'Total Items' }
  ]

  
 
  function selectHeader(headerId, headerLabel) {
    const headerObj = { "id": headerId, "label": headerLabel}
    const currentSelected = selectedHeaders
    currentSelected.push(headerObj)
    setColumnsOpen(false)
    setSelectedHeaders(currentSelected)
  }

  function resetTableHeaders() {
    setSelectedHeaders([
      { id: 'incrementId', label: 'Invoice Number' }, { id: 'orderId', label: 'Order ID'}, { id: 'orderDate', label: 'Placed On'},
      { id: 'subtotal', label: 'Subtotal'}, { id: 'shippingCharges', label: 'Shipping Charges' },
      { id: 'items', label: 'Total Items' }
    ])
    setColumnsOpen(false)
  }
  console.log("data sumery",summary);

  React.useEffect(() => {
    let submitPayload = {
      "orderId": summary.order_id,
      "type" : "invoice"
      
      
    }
    axios.post(`${legolasApi.url}/orders/order/particular`, submitPayload).then((res) => {
      console.log('Response: ', res)
      const data = res.data
        if (data.data && isArray(data.data)) {
          setInvoiceList(res.data.data);
          } else {
            setInvoiceList([])
          }
          console.log(res.data);
        })
}, [])

  const trimId = (inputId) => {
    return inputId.substring(0, 7);
  }

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' +  year + '  ' + formattedTime
  }

  const handleEditClick = (orderId, order) => {
    const link =  `/invoice/${orderId}`
    navigate(link, { state: { data: order, source: 'order-details' }})
  }

  const localStorageUser = localStorage.getItem('user');
	const user = JSON.parse(localStorageUser);
	const userid = user.id

  return (
    <React.Fragment>
      <List actions={null}>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
            <Typography variant='h4'>Invoices</Typography>
           </Box>
           </Box>
        <Box>
        {
                    isArray(invoiceList) && invoiceList.length > 0 ?
          <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
          <Table aria-label="simple table">
              <TableHead sx={{ 
                backgroundColor: globalStyles.colors.backgroundPrimary, 
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important',
                  borderRight: '2px solid #fff !important',
                  borderRadius: '0 !important'
                }
              }}>
                {selectedHeaders.map((header) => [
                  <StyledTableCell align='center'>{header.label}</StyledTableCell>
                ])}
                <StyledTableCell align='center'>Action</StyledTableCell>
              </TableHead>
              <TableBody>
                {invoiceList.map((order) => {
                      return (
                        <StyledTableRow id={order._id} key={order._id}>
                          {selectedHeaders.map((header) => {
                            if(header.id === '_id'){
                              return (
                                <Tooltip title={order[header.id]}>
                                  <StyledTableCell align='center'>{trimId(order[header.id])}</StyledTableCell>
                                </Tooltip>
                              )
                            }else if (header.id === 'createdAt') {
                              return (
                                <StyledTableCell align='center'>{formatDateAndTime(new Date(order[header.id]))}</StyledTableCell>
                              )
                            } else if (header.id == 'items') {
                              return (
                                <StyledTableCell align='center'>{order[header.id].length}</StyledTableCell>
                              )
                            } else {
                              return (
                                <StyledTableCell align='center'>
                                  {order[header.id]}
                                </StyledTableCell>
                              )
                            }
                          })}
                          <StyledTableCell align='center'>
                          {!(userid === 159 && userid === 160) ? <Button  onClick={() => handleEditClick(order.orderId, order)} >View</Button> : null}
                          </StyledTableCell>
                        </StyledTableRow>
                      )
                    })}
              </TableBody>
            </Table>
          </TableContainer>
           :
           <Box>
             <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', fontStyle: 'oblique' }}>No items added in Invoice</Typography>
           </Box>
           }
        </Box>
      </List>
    </React.Fragment>
  )
}

export default OrderInvoiceList